module.exports = __webpack_public_path__ + "static/media/wave-long.159dda17.svg";